"use strict";import EventEmitter from"./_EventEmitter";export default EventEmitter;